import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  reviewsPageAdditionalMeta,
  reviewsPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ReviewsPageMainContainer from '../../components/reviews/ReviewsPageMainContainer';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
import FooterComponent from '../../components/footer/FooterComponent';

function ReviewsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Customer Reviews'
        desc={`Read authentic testimonials from devoted submissives and clients who have experienced the unique power and presence of ${CompanyName}. Discover how Mistress Maria has captivated, trained, and transformed those who surrender to her control.`}
        keywords={`Mistress Maria reviews, Dominatrix testimonials, submissive experiences, BDSM feedback, Femdom sessions UK, Norfolk Dominatrix, client stories, submissive training feedback, powerful Mistress`}
        additionalMeta={reviewsPageAdditionalMeta}
        structuredData={reviewsPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'Testimonials'} />
          </header>
        </div>

        {/* Main page content */}
        <ReviewsPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default ReviewsPage;
